import React, {useState, useEffect} from "react";
import {APP_URL, IMG_URL, amount_format,discount,showRatingP} from '../components/config/Common'

import { BiRupee } from "react-icons/bi";
import { motion as ms } from 'framer-motion';
import {Links} from '../routes/PathLink'
import { Link } from "react-router-dom";
import SavePriceInd from '../ui/SavePriceInd'


const ProductCard = ({
   item,
   upcoming
}:props) => {

   const [user_type, setUser_type] = useState('')

    useEffect(() => {
      
         const user_type = localStorage.getItem('user_type');
         setUser_type(user_type);
       
    }, [])

   return(
      <Link to={`${Links.PRODUCT}/${item.product_slug}`}>
         <ms.article 
         layout
         initial={{ y: 10, opacity: 0 }}
         animate={{ y: 0, opacity: 1 }}
         exit={{ y: -10, opacity: 0 }}
         transition={{ duration: 0.5 }}
         className="group product-card cart-type-krypton h-full cursor-pointer overflow-hidden rounded border border-border-200 bg-light dark:bg-gray-700 dark:border-none transition-shadow duration-200 hover:shadow-sm" >
            <div className="relative flex h-48 w-auto items-center justify-center sm:h-64">      
               <div className="absolute top-3 flex justify-start gap-2">

                  {
               item.is_featured == 1 && 
               <div class=" rounded bg-yellow-500 px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Featured</div>
               }
                {
               item.is_popular == 1 && 
               <div class=" rounded bg-[#7D87D4] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Popular</div>
               }

               {
               item.is_verified == 1 && 
               <div class=" rounded bg-[#8D9557] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Verified</div>
               }
               {
               item.is_upcoming == 1 && 
               <div class=" rounded bg-[#00A09D] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Upcoming</div>
               }

               {
               item.in_stock == 0 && 
               <div class=" rounded bg-[#CB797B] px-1.5 text-xs font-semibold leading-6 text-light ltr:left-3 rtl:right-3 sm:px-2 md:top-4 md:px-2.5 ltr:md:left-4 rtl:md:right-4">Out Of Stock</div>
               }
               </div>
             
               
               {
               !upcoming &&
               <>
               {
               item.availability_status && item.availability_status !== 'available' ?
               <div class="absolute bg-dark text-center text-light w-full bg-opacity-50 text-md py-3 capitalize h-full flex items-center justify-center">
                  <span className={"bg-red-100 text-red-800 border-red-400 text-md font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border capitalize"}>{item.availability_status}</span>
               </div>
               :null
               }
               </>
               }
               
               {
                  item.product_image
                  ?
                  <img src={`${IMG_URL}${item.product_image}`} className="h-48 w-full sm:h-64 object-cover" alt={item.product_name} sizes="100vw" />
                  :
                  <img src={`${APP_URL}/img/no-image-available.png`} alt={item.product_name} sizes="100vw" />
               }
         
            </div>
            <header className="relative p-3 md:p-2 md:pb-3">
               <h3 role="button" className="mb-1 truncate text-base text-heading dark:text-zinc-400">{item.product_name}</h3>
               {/* <p className="text-xs text-muted">1pc(s)</p> */}
               <div className="mb-1 truncate text-base text-heading dark:text-zinc-400">
                  {
                     //let item.price.toLocaleString()
                  <div className="relative">
                     {user_type == 'dealer' && item.dealer_price &&  item.dealer_price > 0 ?
                        (<span className="text-sm  text-accent md:text-base flex items-center">
                        {amount_format(item.dealer_price)}
                        </span>)
                        :
                        ( 
                        <>
                        {item.warranty_price && item.warranty_price > 0 ?
                        <><span className="text-sm  text-accent md:text-base flex items-center">
                        {amount_format(item.warranty_price)}
                        </span>
                        {user_type != 'dealer' &&
                         <SavePriceInd max={item.sale_price} min={item.warranty_price} />
                        }
                        </>
                           :
                        <>
                        {item.dealer_price && item.dealer_price > 0 ?
                           <><span className="text-sm  text-accent md:text-base flex items-center">
                           {amount_format(item.dealer_price)}
                           </span>
                           {user_type != 'dealer' &&
                            <SavePriceInd max={item.sale_price} min={item.dealer_price} />
                           }
                           </>
                           :
                            <><span className="text-sm  text-accent md:text-base flex items-center">
                           {amount_format(item.price)}
                           </span>
                           {user_type != 'dealer' &&
                            <SavePriceInd max={item.sale_price} min={item.price} />
                           }
                           </>
                        }
                        </>
                        }
                        </>

                        )
                     }
                     
                  </div>
                  }
                  
                    {item.ratings &&
                            <div class="flex text-xs items-center justify-start gap-1">
                               <div class="text-body">
                                {item.ratings}
                              </div>
                              <div class="flex">
                              {showRatingP(item.ratings)} 
                              </div>
                              <div class="text-body">
                                ({item.total_reviews})
                              </div>
                            </div>
                            }
                  <div class="flex bg-light text-accent  group-hover:bg-accent group-hover:text-light ease-in duration-300 rounded-full w-[45%] items-center justify-between mt-1">
                     <div class="uppercase text-xs ease-in duration-300 pl-1 group-hover:pl-2">Add to Cart</div><div class="relative -right-[1px] h-7 w-7 bg-accent text-light group-hover:bg-light group-hover:text-accent rounded-full flex items-center justify-center"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l.5 2H5V5H3.14zM6 5v2h2V5H6zm3 0v2h2V5H9zm3 0v2h1.36l.5-2H12zm1.11 3H12v2h.61l.5-2zM11 8H9v2h2V8zM8 8H6v2h2V8zM5 8H3.89l.5 2H5V8zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"></path></svg>
                    </div>
                  </div>
               </div>
               
                   
                  
            </header>
         </ms.article>
      </Link>
   )
}

export default ProductCard;